module.exports = __webpack_public_path__ + "static/media/bankcards.4d209743.png";